<template>
  <svg class="icon-vector" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="outline">
      <polygon id="#r_bg" :style="'fill:' + reportFill" stroke-width="3" stroke="#000" points="45.7,7.8 20.8,7.8 14.3,14.3 14.3,52.2 45.7,52.2"/>
      <polygon fill="#000" points="22,15 22,7 14,15  "/>
    </g>
    <g id="contents">
      <line id="r_line6" x1="20" y1="45" x2="40" y2="45" :stroke="strokeColor" />
      <line id="r_line5" x1="20" y1="40" x2="40" y2="40" :stroke="strokeColor"/>
      <line id="r_line4" x1="30" y1="35" x2="40" y2="35" :stroke="strokeColor"/>
      <line id="r_line3" x1="30" y1="30" x2="40" y2="30" :stroke="strokeColor"/>
      <line id="r_line2" x1="20" y1="25" x2="40" y2="25" :stroke="strokeColor"/>
      <line id="r_line1" x1="20" y1="20" x2="40" y2="20" :stroke="strokeColor"/>
      <rect id="r_box" x="21" y="25" :stroke="boxStroke" width="5" height="5"/>
    </g>
  </svg>
</template>

<script>
import { mapState } from 'vuex'
import { TimelineMax, TweenMax, Power2 } from 'gsap'
import { shadeBlendConvert } from '@/lib/funcs'

export default {
  name: 'report-icon',
  data () {
    return {
      progressTween: undefined,
      complete: false,
      reportColor: '#ccc'
    }
  },
  watch: {
    numCompleted () {
      this.progressTween.tweenTo( 'completed' + this.numCompleted )
    }
  },
  computed: {
    reportFill () {
      return this.complete ? this.selectedColor : 'rgba(250, 250, 250, 0)'
    },
    boxStroke () {
      return this.complete ? shadeBlendConvert( -0.5, this.selectedColor ) : '#969696'
    },
    strokeColor () {
      return this.complete ? this.selectedAccent : '#000'
    },
    ...mapState( {
      numCompleted: state => state.demos.numCompleted,
      selectedColor: state => shadeBlendConvert( 0.5, state.report.color ),
      selectedAccent: state => shadeBlendConvert( 0.5, state.report.accent )
    } )
  },
  mounted () {
    TweenMax.set( '#r_box', { x: -5, opacity: 0 } )
    TweenMax.set( '#r_line1', { scaleX: 0 } )
    TweenMax.set( '#r_line2', { y: -5 } )
    TweenMax.set( ['#r_line3', '#r_line4'], {
      y: -5,
      transformOrigin: 'top right',
      scaleX: 2
    } )
    TweenMax.set( '#r_line5', { y: -5 } )
    TweenMax.set( '#r_line6', { y: -5, scaleX: 0.25 } )

    let demo1 = new TimelineMax()
    demo1.add( TweenMax.to( '#r_line3', 0.5, { scaleX: 1, ease: Power2.easeOut } ) )
    demo1.add( TweenMax.to( '#r_line4', 0.5, { delay: 0.1, scaleX: 1, ease: Power2.easeOut } ), 0 )
    demo1.add( TweenMax.to( '#r_box', 0.5, { x: 0, opacity: 1, ease: Power2.easeOut } ), 0.25 )
    demo1.add( TweenMax.to( '#r_line6', 0.5, { scaleX: 0.75, ease: Power2.easeOut } ), 0.5 )

    let demo2 = new TimelineMax()
    demo2.add( TweenMax.staggerTo( ['#r_line6', '#r_line5', '#r_line4', '#r_line3', '#r_line2'], 0.5, { y: 0, ease: Power2.easeOut }, 0.075 ) )
    demo2.add( TweenMax.to( '#r_box', 0.5, { y: 5, ease: Power2.easeOut } ), 0.25 )
    demo2.add( TweenMax.to( '#r_line1', 0.5, { scaleX: 1, ease: Power2.easeOut } ), 0.5 )

    this.progressTween = new TimelineMax( { paused: true } )
    this.progressTween.add(demo1)
    this.progressTween.addLabel( 'completed1' )
    this.progressTween.add(demo2)
    this.progressTween.addLabel( 'completed2' )
    this.progressTween.add( TweenMax.to( this, 0, { delay: 1, complete: true } ) )
    this.progressTween.addLabel( 'completed3' )

    this.progressTween.tweenTo( 'completed' + this.numCompleted, { delay: 1 } )
  }
}
</script>

<style lang="scss" scoped>
.icon-vector {
  line {
    stroke-width: 2;
    transition: stroke 1s cubic-bezier(0.640, 0.000, 0.355, 1.000);
  }

  polygon {
    transition: fill 1s cubic-bezier(0.640, 0.000, 0.355, 1.000);
  }

  #r_bg {
    fill: rgba(250, 250, 250, 0);
  }

  rect {
    stroke-width: 2;
    fill: none;
    transition: stroke 1s cubic-bezier(0.640, 0.000, 0.355, 1.000);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/svg/ReportIcon.vue